import InternalServer from '@/components/common/InternalServer'
import LoadingScreen from '@/components/common/LoadingScreen'
import * as React from 'react'

/**
 * An error screen that will be used as a fallback UI.
 * @see https://reactjs.org/docs/error-boundaries
 */

const reloadPageWhenErrorMessage = [
  'Failed to fetch dynamically imported module',
  'Unable to preload CSS ',
  'Failed to load module script',
]

const errorMessagesRegex = new RegExp(reloadPageWhenErrorMessage.join('|'))

export class ErrorBoundary extends React.Component<Props> {
  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { error }
  }

  override state: State = { error: undefined }

  override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (error.message.match(errorMessagesRegex)) {
      window.location.reload()
      return
    }
    // You can also log the error to an error reporting service
    console.error(error, errorInfo)
  }

  override render() {
    const { error } = this.state

    if (!error) {
      return this.props.children
    }

    if (error.message.match(errorMessagesRegex)) {
      return <LoadingScreen />
    }

    return <InternalServer />
  }
}

type Props = {
  children: React.ReactNode
}

type State = {
  error: (Error & { status?: number }) | undefined
}
